import { Package } from "lucide-react";

export function PickupStrip({ tickets }) {
  return (
    <div
      data-testid="pickup-strip"
      className="h-16 w-full flex items-center gap-4 px-5 border-t border-white/[0.08] bg-[#0F172A]/60 shrink-0"
    >
      <div className="flex items-center gap-1.5 shrink-0">
        <Package className="w-4 h-4 text-violet-400" strokeWidth={1.5} />
        <span className="font-display text-xs font-semibold text-violet-400 tracking-wider">READY FOR PICKUP</span>
      </div>
      <div className="h-5 w-px bg-white/10" />
      <div className="flex gap-3 overflow-hidden flex-1 items-center">
        {tickets.length === 0 ? (
          <span className="text-sm text-slate-600">No devices ready</span>
        ) : tickets.map(t => (
          <div
            key={t.id}
            data-testid={`pickup-${t.ticket_number}`}
            className="flex items-center gap-3 px-3.5 py-2 bg-violet-500/8 border border-violet-500/20 rounded text-sm"
          >
            <span className="font-bold text-[18px] text-white px-2 py-0.5 rounded border border-violet-400/50 bg-violet-500/10 leading-none whitespace-nowrap" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{t.ticket_number}</span>
            <span className="text-slate-200 truncate max-w-[180px] font-medium">{t.device_name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
